import React from 'react';
import { connect } from 'react-redux';
import { actions as modalActions } from '@wix/da-shared-react/pkg/Modals';
import { Props as ConfirmationPopupProps } from '@wix/da-shared-react/pkg/Popup/ConfirmationPopup';

export interface WithConfirmationModal {
  pushConfirmationModal: (props: ConfirmationPopupProps) => void;
}

export const withConfirmationModal = <T extends object>(
  Component: React.ComponentType<T>
) => {
  class ComponentWithConfirmationModal extends React.Component<
    Partial<T & WithConfirmationModal>
  > {
    render() {
      return <Component {...this.props as T} />;
    }
  }
  return connect(
    null,
    {
      pushConfirmationModal: modalActions.pushConfirmationModal,
    }
  )(ComponentWithConfirmationModal);
};

export default withConfirmationModal;
